/* eslint-disable perfectionist/sort-imports */
import 'src/utils/highlight';

import ReactQuill, { Quill } from 'react-quill';
import { useMemo } from 'react';

import { alpha } from '@mui/material/styles';

import { EditorProps } from './types';
import { StyledEditor } from './styles';
import Toolbar, { formats } from './toolbar';

// ----------------------------------------------------------------------

const FontStyle = Quill.import('attributors/style/font') as any;
FontStyle.whitelist = ['georgia', 'helvetica', 'courier'];
Quill.register(FontStyle, true);

const SizeStyle = Quill.import('attributors/style/size') as any;
SizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '32px', '48px'];
Quill.register(SizeStyle, true);

export default function Editor({
  id = 'minimal-quill',
  error,
  simple = false,
  helperText,
  sx,
  ...other
}: EditorProps) {
  const modules = useMemo(
    () => ({
      toolbar: {
        container: `#${id}`,
      },
      history: {
        delay: 500,
        maxStack: 100,
        userOnly: true,
      },
      syntax: true,
      clipboard: {
        matchVisual: false,
      },
    }),
    [id]
  );

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
            '& .ql-editor': {
              bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
            },
          }),
          '& .ql-editor': {
            backgroundColor: (theme) => theme.palette.background.paper,
          },
          ...sx,
        }}
      >
        <Toolbar id={id} simple={simple} />

        <ReactQuill
          modules={modules}
          formats={formats}
          placeholder="Escreva aqui a mensagem do email..."
          style={{ backgroundColor: 'transparent' }}
          {...other}
        />
      </StyledEditor>

      {helperText && helperText}
    </>
  );
}
